import { gql } from '@apollo/client';

export interface SavedLayoutFragment {
    id: string;
    datasetId: number;
    isPreferred: boolean;
    preferredForGroupIds: string[];
    name: string;
    fixtures: string;
    orders: string;
    commonSettings: {
        directionLogic: string;
        quantityFormat: string;
        rateFormat: string;
        defaultType: string;
    };
}

export const SAVED_LAYOUT_FRAGMENT = gql`
    fragment SavedLayoutFragment on SavedLayout {
        id
        datasetId
        isPreferred
        preferredForGroupIds
        name
        fixtures
        orders
        commonSettings {
            directionLogic
            quantityFormat
            rateFormat
            defaultType
        }
    }
`;
